var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconZoomInComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-zoom-in ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6167 7.38298C3.6167 5.2889 5.31429 3.59131 7.40838 3.59131C9.50246 3.59131 11.2001 5.2889 11.2001 7.38298C11.2001 9.47707 9.50246 11.1747 7.40838 11.1747C5.31429 11.1747 3.6167 9.47707 3.6167 7.38298ZM7.40838 2.25781C4.57782 2.25781 2.2832 4.55243 2.2832 7.38298C2.2832 10.2135 4.57782 12.5082 7.40838 12.5082C8.5702 12.5082 9.64174 12.1216 10.5014 11.47L12.5383 13.5069C12.6685 13.6371 12.8796 13.6371 13.0098 13.5069L13.4812 13.0355C13.6114 12.9053 13.6114 12.6942 13.4812 12.564L11.451 10.5338C12.1293 9.66459 12.5335 8.57099 12.5335 7.38298C12.5335 4.55243 10.2389 2.25781 7.40838 2.25781ZM4.88125 7.07032C4.88125 6.88621 5.03051 6.73695 5.21463 6.73695H6.71148V5.23999C6.71148 5.05587 6.86074 4.90662 7.04485 4.90662H7.7116C7.89572 4.90662 8.04498 5.05587 8.04498 5.23999V6.73695H9.54194C9.72605 6.73695 9.87531 6.88621 9.87531 7.07032V7.73707C9.87531 7.92119 9.72605 8.07045 9.54194 8.07045H8.04498V9.5673C8.04498 9.75142 7.89572 9.90068 7.7116 9.90068H7.04485C6.86074 9.90068 6.71148 9.75142 6.71148 9.5673V8.07045H5.21463C5.03051 8.07045 4.88125 7.92119 4.88125 7.73707V7.07032Z",
    fillOpacity: "1"
  }));
}
var IconZoomIn = /*#__PURE__*/React.forwardRef(IconZoomInComponent);
export default IconZoomIn;